<template>
  <div>
    <radio-group
      v-model="inputValue"
      v-bind="$attrs"
      :items="formattedItems"
      :errors="errors"
      :required="required"
      @input="$emit('input', inputValue)"
    />
  </div>
</template>

<script>
export default {
  name: 'RadioGroupWrapper',
  components: {
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: {
      type: String || Number,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    required: Boolean,
  },
  data() {
    return {
      inputValue: null,
      errors: null,
    }
  },

  computed: {
    formattedItems() {
      return this.items.map(el => {
        return {
          value: el.value,
          text: el.name,
        }
      })
    },
  },

  created() {
    this.inputValue = this.value
  },
}
</script>

<style scoped></style>
